export enum PageType {
  DASHBOARD = 'adminPortalDashboard',
  EMPLOYEE = 'adminPortalEmployees',
  DEPARMENT = 'adminPortalDepartments',
  LOCATION = 'adminPortalLocations',
  EXPENSE_CODE = 'adminPortalExpenseCodes',
  COST_CENTER = 'adminPortalCostCenters',
  ALLOWANCE = 'adminPortalAllowance',
  SUBSCRIPTION = 'adminPortalSubscription',
  REPORT = 'adminPortalReports',
  USER_GUIDE = 'adminPortalUserGuide',
  GIFT_CARD = 'adminPortalGiftCard'
}

export interface GaEventPayload {
  pageType: PageType;
  pageUrlPath: string;
  eventPlatform: 'b2b';
  userLoggedIn: boolean;
  event: string;
}
